import { render, staticRenderFns } from "./ilabel.vue?vue&type=template&id=6d1e6bdb&scoped=true&"
import script from "./ilabel.vue?vue&type=script&lang=js&"
export * from "./ilabel.vue?vue&type=script&lang=js&"
import style0 from "./ilabel.vue?vue&type=style&index=0&id=6d1e6bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e6bdb",
  null
  
)

export default component.exports